const en_ID = {
    header:{
        home:'Halaman beranda',
        create: 'Membuat',
        benefits:'Keuntungan Penulis',
        lang: 'Bahasa'
    },
    login:{
        loginbtn: 'Masuk',
        logoutbtn: 'Keluar',
        fblogin:'Masuk dengan Facebook',
        googlelogin:'Masuk dengan Google',
    },
    footer:{
        lianxi: 'Hubungi kami',
        tiaokuan: 'Syarat Penggunaan',
        yinsi: 'Kebijakan Privasi',
        xiazai: 'Unduh Aplikasi',
    },
    create:{
        size: 'Ukuran sampul: 400*560',
        file: 'Format file: .jpg .png',
        upload: 'Mengunggah',
        title: 'Informasi Novel',
        skip: 'Lewati',
        bookTitle: 'Judul Buku',
        bookTitlePlace: 'Dalam 30 karakter',
        genre: 'Jenis',
        genrePlace: 'Silakan pilih jenisnya',
        editor: 'Sunting',
        editorPlace: 'Jika editor (AE) membantu kami mengirim buku Anda untuk ulasan kami, silakan pilih namanya. Jika tidak, silakan pilih "tidak ada".',
        contractType: 'Jenis kontrak',
        targetAudience: 'Targetkan pengguna',
        girl: 'Perempuan',
        boy: 'Pria',
        synopsis: 'Ringkasan',
        description: 'Silakan tulis deskripsi cerita Anda sepanjang 20 hingga 300 kata.',
        descriptionInfo: 'Mohon jangan mengisi informasi yang tidak berhubungan dengan novel.',
        tags: 'Label',
        tagsPlace: 'Silakan pilih setidaknya 3 tag untuk cerita Anda.',
        tagsTips: 'Pilih label dari daftar (hingga 5).',
        leavinglost:'Konten yang diubah setelah meninggalkan halaman akan hilang!',
        edit: 'Sunting',
    },
    authorCenter:{
        stories:{
            title: 'Novel',
            chapters:'Judul',
            words: 'Kata',
            status:'Status',
            newChapters:'Bagian baru',
            noStory:'Tidak ada novel',
            newStory:'Novel baru',
            chapterList:'Daftar bab',
            editStory:'Sunting novel',
            secondaryTitle:['Daftar bab','Permohonan kontrak','Aplikasi selesai','Permohonan bonus','Hapus novel'],
            dujia:'Eksklusif',
            feidujia:'Non-eksklusif',
            // 章节页面所有
            noChapter:'Tanpa Bab',
            Published: 'Diterbitkan',
            Draft: 'Draf',
            // 新建章节
            newChapterPlace:[
                'Judul bab. Misalnya: Bab 1 Pendahuluan.',
                'Minimal 1 kata setiap bab, dan maksimal 3.000 kata.',
                'Silakan masukkan maksimal 30 kata',
                'Pendahuluan novel tidak boleh kurang dari 30 kata.',
                'Silakan isi alamat email Anda sehingga kami dapat menghubungi Anda jika buku Anda disetujui.',
                'email bukan email yang valid',
                'Apakah Anda yakin untuk menghapus bab tersebut?'
            ],
            newChapterBtn:['Menyimpan','Rilis','Menghapus'],
            publishChapter:['Upload otomatis bab Anda', 'Waktu rilis', 'Sekarang', 'Setelah'],
            confirm: 'Mengonfirmasi',
            cancel: 'Membatalkan',
            review: 'Pemeriksaan',
            submit: 'Kirim',
            success: 'Kesuksesan',
            submitted:'Diserahkan',
            infoTips: 'Pemberitahuan pesan',
            chPenName: 'Nama pena Anda (Bahasa Tionghoa)',
            // 签约合同
            contractLabel: [
                'Nama Resmi Anda',
                'Nama pena Anda (Bahasa Inggris)',
                'Surat',
                'Alamat',
                'Jenis rekening bank',
                'Nama Bank',
                'Tukar Kode',
                'Nomor Rekening',
                'Whatsapp',
                'Hadapan kartu ID/Paspor',
                'Bangsa',
                'Kode cabang',
                'Nomor telepon',
                'Silakan tambahkan kode negara Anda misalnya +91 7111111111',
                'Kartu bank',
                'Kode pos Anda',
                'Alamat bank',
                'Kode cabang bank',
                'Kode pos bank',
                'Apakah harus diselesaikan dalam mata uang lokal',
                'diri',
                'dolar',
                'Reverse of ID card',
                'Nomor Routing Bank',
            ],
            contractPlace:[
                'Email diperlukan',
                'Nama bank wajib diisi',
                'Alamat diperlukan',
                'Tukar Kode diperlukan',
                'Nama resmi Anda wajib diisi',
                'Nama pena Anda wajib diisi',
                'Jenis akun wajib diisi',
                'Diperlukan WhatsApp',
                'Nomor telepon diperlukan',
                'KTP/paspor harus diisi',
                'Nomor rekening bank diperlukan',
                'Bangsa diperlukan',
                'Jenis kontrak Anda adalah: ',
                'Jika salah silahkan klik',
                'Di Sini',
                'Edit jenis kontrak Anda.',
                'Alamat bank diperlukan',
                'Kode cabang bank diperlukan',
                'Kode pos bank diperlukan',
                'Kode pos Anda diperlukan',
                'Silakan memilih apakah harus diselesaikan dalam mata uang lokal',
            ],
            contractSign:['Catatan','Sedang ditinjau','Tinjau kontrak'],
            // 作品完结
            completing:[
                'Hanya ada satu peluang untuk menyelesaikan aplikasi per cerita. Setelah status berubah, bab baru tidak akan diterbitkan lagi. Apakah Anda yakin ingin melengkapi aplikasinya?',
                'Apakah Anda yakin ingin melengkapi aplikasinya?',],
            // 奖励
            rewards:[
                'Jika setiap novel yang ditandatangani mencapai 10.000 kata, Anda dapat mengajukan bonus penandatanganan. Bonus akan ditambahkan ke akun Anda nanti.'
            ],
            // 删除
            deleteStory:[
                'Hanya cerita yang tidak dipublikasikan yang dapat dihapus, cerita yang telah dihapus tidak dapat dipulihkan.',
                'Apakah Anda yakin ingin menghapus item ini? Tidak dapat memulihkan setelah dihapus.'
            ],
        },
        income:{
            title: 'Penghasilan',
            Totalincome: 'Total pendapatan',
            Search: 'Mencari',
            rules: ' Aturan penarikan:<br>\n' +
                '              1.  Setelah menjadi penulis kontrak, Anda akan mulai memperoleh penghasilan.<br>\n' +
                '              2. Ketika saldo Anda mencapai $100, Anda dapat menarik penghasilan dari dompet Anda.<br>\n' +
                '              3. Pajak dan biaya yang timbul dari pembayaran tersebut menjadi tanggungan penulis sesuai dengan kebijakan saluran pembayaran.<br>\n' +
                '              4. Permintaan penarikan hanya dapat dilakukan sebulan sekali.<br>\n' +
                '              5. Penarikan dapat dilakukan mulai tanggal 5 hingga 7 setiap bulan (UTC/GMT+08:00). Uang akan ditransfer ke rekening Anda sebelum tanggal 20 setiap bulannya (biasanya tanggal 15).',
            NoIncome:'Tidak ada pendapatan',
            withdrawalBtn:[
                'Ajukan permohonan penarikan',
                'Menunggu persetujuan',
                'Disetujui',],
            withdrawalTable:[
                'Waktu','Jenis pendapatan'
            ],
        },
        inbox:{
            title:'Kotak Masuk',
            System: 'Sistem',
            NoInbox:'Tidak ada pesan'
        },
        profile:{
            title:'Informasi pribadi',
            SAVE:'Menyimpan',
            uploadInfo:[
                'Silakan pilih gambar yang akan diunggah',
                'Gambar tidak boleh melebihi 2M',
            ]
        }
    },
    alert:{
        sucAlert:[
            'Tambahkan berhasil!',
            'Pembaruan berhasil!',
            'Penghapusan berhasil!',
            'Operasi berhasil!',
            'Keluar berhasil'
        ],
        failAlert:[
            'Gagal menambahkan!',
            'Modifikasi gagal!',
            'Penghapusan gagal!',
            'Operasi gagal!'
        ],
    },
    buyOut:{
        title:'Kontrak Pembelian',
        form:[
            'Usia Penulis',
            'Jenis Kelamin Penulis',
            'Jenis Kartu Identitas',
            'ID Dokumen Identitas',
            'PayPal',
            'Email PayPal',
            'Nama Penerima Pembayaran',
            'Kode IFSC',
            'Nomor IBAN',
            'Kode MICR',
            'Nama Asli Wali',
            'Gambar Tanda Tangan Wali',],
        formRules:[
            'Isi Usia Penulis',
            'Isi Jenis Kelamin Penulis',
            'Silakan Pilih Jenis Dokumen Identifikasi',
            'Isi ID Dokumen Identifikasi',
            'Isi email PayPal',
            'Isi Nama Penerima',
            'Isi Kode IFSC',
            'Isi Nomor IBAN',
            'Isi Kode MICR',
            'Isi Nama Lengkap Wali',
            'Gambar Tanda Tangan Wali',
        ]
    },
    tips: {
        agreement: 'Silakan setuju untuk kesepakatan pengguna dan kesepakatan privasi pertama!',
        cannotBeEmpty: 'Alamat surel tidak dapat kosong',
        format: 'Format email tidak benar. Silakan periksa @ symbol and domain name',
        emailLength: 'Panjang surel tidak dapat melebihi 50 karakter paling',  // 邮箱长度最多不能超过50个字符
        inputPassword: 'Silakan masukkan sandi',
        passwordLength: 'Silakan masukkan panjang sandi antara 8-16 karakter', // 密码长度请输入在8~16位之间
        passwords: 'Kata sandi yang dimasukkan dua kali tidak konsisten. Silakan konfirmasi lagi sebelum memasuki!',
        registeredSuccessfully: 'terdaftar dengan sukses!',
        registerFailed: 'login telah gagal!',
        enterChineseName: 'Silakan masukkan nama Tionghoa yang benar',
        penCharacters: 'Nama pena tidak boleh melebihi 50 karakter',
    },
}
export default en_ID;
